import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Grid } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";

import { useWallet } from "../../context/walletProvider";

import { fractionalise } from "../web3Wrapper";
function Form() {
  const wallet = useWallet();
  const history = useHistory();
  const [tokenName, setTokenName] = useState("");
  const [tokenSymbol, setTokenSymbol] = useState("");
  const [tokenValuation, setTokenValuation] = useState("");
  const [tokenDescription, setTokenDescription] = useState("");
  const [tokenLogo, setTokenLogo] = useState("");
  const [tokenLiquidity, setTokenLiquidity] = useState("");
  const tokens = wallet.userTokens;
  let selected;
  if (tokens.length) {
    selected = getFirstApproved(tokens);
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    wallet.setLoadingState(true);
    console.log(
      tokens[selected].tokenAddress,
      tokens[selected].tokenId,
      tokenName,
      tokenSymbol,
      tokenLiquidity,
      tokens[selected].nonce,
      wallet.account
    );
    const receipt = await fractionalise(
      tokens[selected].tokenAddress,
      tokens[selected].tokenId,
      tokenName,
      tokenSymbol,
      tokens[selected].nonce,
      wallet.account,
      tokenLiquidity * 1e18
    );
    let FXNToken = receipt.events[3].address;
    wallet.setLoadingState(false);
    history.push(`/trade/${tokens[selected].nonce}/${FXNToken}`);
    console.log(receipt);
  };

  return (
    <div className="form-container">
      <form
        style={{ marginTop: "100px", margin: "auto" }}
        onSubmit={handleSubmit}
      >
        <Grid container>
          <div className="form-spacing">
            <Grid item>
              <label
                style={{
                  color: "#E0E0E0",
                  fontSize: "8px",
                  letterSpacing: "2px",
                }}
              >
                TOKEN NAME
              </label>
            </Grid>
          </div>
          <Grid item xs={12}>
            <TextField
              size="small"
              style={{
                width: "70%",
                backgroundColor: "#0E0E0E",
                borderRadius: "10px",
                height: "35px",
                marginBottom: "30px",
                color: "#E0E0E0",
              }}
              variant="outlined"
              InputLabelProps={{ className: "text-label" }}
              InputProps={{ className: "input-field" }}
              //Value inside context
              value={tokenName}
              onChange={(e) => {
                setTokenName(e.target.value);
              }}
            />
          </Grid>
          <div className="form-spacing">
            <Grid item>
              <label
                style={{
                  color: "#E0E0E0",
                  fontSize: "8px",
                  letterSpacing: "2px",
                }}
              >
                TOKEN SYMBOL
              </label>
            </Grid>
          </div>
          <Grid item xs={12}>
            <TextField
              size="small"
              style={{
                width: "70%",
                backgroundColor: "#0E0E0E",
                borderRadius: "10px",
                height: "35px",
                marginBottom: "30px",
              }}
              variant="outlined"
              InputLabelProps={{ className: "text-label" }}
              InputProps={{ className: "input-field" }}
              //Value inside context
              value={tokenSymbol}
              onChange={(e) => {
                setTokenSymbol(e.target.value);
              }}
            />
          </Grid>
          <div className="form-spacing">
            <Grid item>
              <label
                style={{
                  color: "#E0E0E0",
                  fontSize: "8px",
                  letterSpacing: "2px",
                }}
              >
                VALUATION(ETH)
              </label>
            </Grid>
          </div>
          <Grid item xs={12}>
            <TextField
              size="small"
              style={{
                width: "70%",
                backgroundColor: "#0E0E0E",
                borderRadius: "10px",
                height: "35px",
                marginBottom: "30px",
              }}
              variant="outlined"
              InputLabelProps={{ className: "text-label" }}
              InputProps={{ className: "input-field" }}
              //Value inside context
              value={tokenValuation}
              onChange={(e) => {
                setTokenValuation(e.target.value);
                setTokenLiquidity(
                  (0.3 * parseFloat(e.target.value)).toFixed(4)
                );
              }}
            />
          </Grid>
          <div className="form-spacing">
            <Grid item>
              <label
                style={{
                  color: "#E0E0E0",
                  fontSize: "8px",
                  letterSpacing: "2px",
                }}
              >
                DESCRIPTION
              </label>
            </Grid>
          </div>
          <Grid item xs={12}>
            <TextField
              size="small"
              style={{
                width: "70%",
                backgroundColor: "#0E0E0E",
                borderRadius: "10px",
                marginBottom: "30px",
              }}
              variant="outlined"
              multiline
              rows={3}
              InputLabelProps={{ className: "text-label" }}
              InputProps={{ className: "input-field" }}
              //Value inside context
              value={tokenDescription}
              onChange={(e) => {
                setTokenDescription(e.target.value);
              }}
            />
          </Grid>

          <Button
            style={{
              borderRadius: "15px",
              boxShadow: "0px 9px 14px rgba(255, 255, 255, 0.2)",
              fontSize: "10px",
              marginLeft: "20%",
            }}
            variant="contained"
            size="small"
            type="submit"
          >
            Fractionalize
          </Button>
        </Grid>
      </form>
    </div>
  );
}
function getFirstApproved(tokens) {
  for (let index = 0; index < tokens.length; index++) {
    if (tokens[index].isApproved && tokens[index].status == 0) {
      return index;
    }
  }
}
export default Form;
